module.exports = __webpack_public_path__ + "img/icon-lock@3x.2cb2ec4a.png";